import React from 'react';
import { Box, InputAdornment, MenuItem, TextField, Typography } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { useTranslation } from 'react-i18next';
import { FilterList } from '@mui/icons-material';

const useStyles = makeStyles(theme => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    gap: theme.spacing(1.5),
  },
  selectField: {
    flex: 1,
    minWidth: 170,
    '& .MuiOutlinedInput-root': {
      minHeight: 56,
    },
  },
  countLabel: {
    whiteSpace: 'nowrap',
    color: theme.palette.text.primary,
    fontSize: '1.2rem',
    fontWeight: 700,
  },
}));

const SimpleFilter = ({ options, tableDataParams, setTableDataParams, displayedRangeLabel }) => {
  const { t } = useTranslation();

  const classes = useStyles();

  return (
    <Box className={classes.container}>
      <TextField
        select
        fullWidth
        className={classes.selectField}
        variant="outlined"
        size="medium"
        label={t('sortBy')}
        value={(tableDataParams.sorts && tableDataParams.sorts[0].value) || ''}
        onChange={({ target: { value } }) => {
          const currentSort = options.find(o => o.value === value);
          tableDataParams.sorts = [currentSort];
          tableDataParams.currentPage = 1;
          setTableDataParams({ ...tableDataParams });
        }}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <FilterList fontSize="small" />
            </InputAdornment>
          ),
        }}
        SelectProps={{
          MenuProps: {
            className: classes.selectMenu,
          },
          IconComponent: () => null,
        }}>
        {options &&
          options.length > 0 &&
          options.map(option => (
            <MenuItem
              key={option.value}
              classes={{
                root: classes.selectMenuItem,
                selected: classes.selectMenuItemSelected,
              }}
              value={option.value}>
              {option.name}
            </MenuItem>
          ))}
      </TextField>
      {displayedRangeLabel ? (
        <Typography className={classes.countLabel} variant="body1">
          {displayedRangeLabel}
        </Typography>
      ) : null}
    </Box>
  );
};

export default SimpleFilter;
